import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MobileGuard} from './shared/services/mobile.guard';
import {VipGuard} from './shared/services/vip.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'mobile',
    pathMatch: 'full'
  },
  {
    path: 'vip',
    loadChildren: './live/live.module#LiveModule',
    canActivate: [VipGuard]
  },
  {
    path: 'mobile',
    loadChildren: './mobile/mobile.module#MobileModule',
    canActivate: [MobileGuard]
  },
  {
    path: 'shared',
    loadChildren: './shared/shared.module#SharedModule'
  },
  {
    path: '**',
    redirectTo: 'mobile'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
